import { render, staticRenderFns } from "./Game2-5.vue?vue&type=template&id=3ad311a0&scoped=true&"
import script from "./Game2-5.vue?vue&type=script&lang=js&"
export * from "./Game2-5.vue?vue&type=script&lang=js&"
import style0 from "./Game2-5.vue?vue&type=style&index=0&id=3ad311a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad311a0",
  null
  
)

export default component.exports